<template>
  <el-dialog
    append-to-body
    center
    dialogDrag
    class="addDialog"
    title="附件预览"
    :model-value="$store.state.previewImageShow"
    :before-close="handleClose"
    :close-on-click-modal="false"
    width="80%"
    @open="open"
  >
    <div
      class="dialog-form"
      style="height: calc(98vh - 75px); text-align: center"
    >
      <iframe class="contentBox" fit="contain" :src="fileUrl"></iframe>
    </div>
  </el-dialog>
</template>

<script>
import { } from '@/api/api'
import axios from 'axios'
export default {
  name: 'previewImage',
  props: [],
  created () { },
  data () {
    return {
      fileUrl: ''
    }
  },
  methods: {
    open () {
      const Base64 = require('js-base64').Base64
      this.fileUrl = '/view/onlinePreview?url=' + Base64.encode(this.$store.state.previewImageUrl)
    },
    //  关闭弹窗
    handleClose () {
      this.$store.state.previewImageShow = false
      this.fileUrl = ''
    }
  }
}
</script>
<style scoped lang="scss">
.contentBox {
  width: 100%;
  height: 98%;
}
</style>
